import React from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { IconButton,Tooltip } from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import ModeEditOutlineTwoToneIcon from "@mui/icons-material/ModeEditOutlineTwoTone";
import AppTable from "components/Shared/AppTable";
import TableFilter from "components/Shared/AppTable/TableFilter";
import { useTablePagination, useAppMeta } from "hooks";
import HighlightedText from "components/Shared/HighlightedText";
import {
  useLazyListContractorQuery,
} from "store/services/contractorApi";

export const ContractorTab = () => {
  const { id: contractorUser } = useParams();
  const [searchParams] = useSearchParams();
  const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
    useTablePagination();

  const activeTab = searchParams.get("tab") || "Active";
  const keyword = searchParams.get("search") || "";

  const columns = [
    {
      name: "Name",
      selector: (row) => row?.name,
      cell: (row) => (
        <div title={row?.name} className="line-clamp-2">
          {row?.name}
        </div>
      ),
      minWidth: "200px",
    },
    {
      name: "Contractor ID",
      selector: (row) => row?.contractorId,
      cell: (row) => (
        <div title={row?.contractorId} className="line-clamp-2">
          <HighlightedText text={row?.contractorId} highlight={keyword} />
        </div>
      ),
      minWidth: "150px",
    },
    {
      name: "Phone",
      selector: (row) => row?.phone,
      cell: (row) => (
        <div title={row?.phone} className="line-clamp-2">
          {row?.phone}
        </div>
      ),
      minWidth: "150px",
    },
    {
      name: "Email",
      selector: (row) => row?.email,
      cell: (row) => (
        <div title={row?.email} className="line-clamp-2">
          {row?.email}
        </div>
      ),
      minWidth: "200px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link to={`/app/crm/contractor/${row._id}/detail`}>
            <Tooltip title="View Profile Detail" arrow>
              <IconButton size="small" aria-label="View Detail">
                <InfoOutlined color="primary" />
              </IconButton>
            </Tooltip>
          </Link>

          <Link to={`/app/crm/contractor/${row._id}/edit`}>
            <Tooltip title="Edit Profile" arrow>
              <IconButton size="small" aria-label="Edit">
                <ModeEditOutlineTwoToneIcon />
              </IconButton>
            </Tooltip>
          </Link>

        </>
      ),
      ignoreRowClick: true,
      right: true,
    },
  ];

  const [
    fetchContractors,
    {
      data: contractorList,
      isLoading: loadingContractors,
      isFetching: fetchingContractors,
    },
  ] = useLazyListContractorQuery();

  React.useEffect(() => {
    fetchContractors({
      status: activeTab,
      keywords: keyword,
      page: currentPage,
      limit: perPage,
      contractorUser,
      ...(keyword && { keyword }),
    });
  }, [
    activeTab,
    fetchContractors,
    keyword,
    currentPage,
    perPage,
    contractorUser,
  ]);

  useAppMeta(`${activeTab} Contractors`);

  return (
    <>
      <TableFilter searchLabel="Contractor ID/Phone/Email">
        <div className="font-medium">{activeTab} Contractors</div>
      </TableFilter>

      <AppTable
        columns={columns}
        data={contractorList?.data ?? []}
        paginationServer
        paginationPerPage={perPage}
        paginationDefaultPage={currentPage}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
        progressPending={loadingContractors || fetchingContractors}
        paginationTotalRows={contractorList?.totalItems ?? 0}
      />
    </>
  );
};
